var _rect, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobListLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C43.464 56 56 43.464 56 28Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1464 14.3532L13.6697 19.517C12.9753 19.8037 12.9809 20.7893 13.6809 21.0665L26.2081 26.0354C27.3113 26.4722 28.5377 26.4722 29.6353 26.0354L42.1681 21.0665C42.8681 20.7893 42.8736 19.8037 42.1792 19.517L29.7025 14.3532C28.5657 13.8823 27.2832 13.8823 26.1464 14.3532Z",
    fill: "#FCB400"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0361 28.7489V41.163C29.0361 41.7533 29.6298 42.1576 30.1786 41.9397L44.1449 36.5201C44.4641 36.3935 44.6714 36.0855 44.6714 35.7428V23.3293C44.6714 22.7385 44.0777 22.3341 43.5289 22.552L29.5626 27.9717C29.2434 28.0982 29.0361 28.4062 29.0361 28.7489Z",
    fill: "#18BFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.777 29.3897L21.633 31.3906L21.2074 31.5939L12.4602 35.7855C11.9058 36.0526 11.2002 35.6488 11.2002 35.0328V23.3815C11.2002 23.1586 11.3122 22.966 11.469 22.8209C11.5306 22.7571 11.6034 22.7044 11.6818 22.6624C11.889 22.537 12.1858 22.5034 12.4378 22.6037L25.7042 27.8598C26.3818 28.1269 26.4322 29.0722 25.777 29.3897Z",
    fill: "#F82B60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.308 29.8448L21.164 31.8457L11 23.276C11.0616 23.2122 11.1344 23.1595 11.2128 23.1175C11.42 22.9921 11.7168 22.9585 11.9744 23.0587L25.2352 28.3149C25.9128 28.582 25.9632 29.5273 25.308 29.8448Z",
    fill: "black",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobListLogo2);
export default __webpack_public_path__ + "static/media/job-list-logo-2.dca64df1e89aa8bb04b61a5d67c1d863.svg";
export { ForwardRef as ReactComponent };